import axios from 'axios';
import { has, isString, isObject, isFunction } from 'lodash';

const validateRequest = request => {
  if (
    has(request, 'url') &&
    has(request, 'type') &&
    isString(request.type) &&
    !isObject(request.url)
  ) {
    if (isFunction(axios[request.type.toLowerCase()])) {
      return true;
    }
    return false;
  }
  return false;
};

const validateConfig = config => {
  if (!isObject(config) && !config.baseURL) {
    return false;
  }
  if (config.timeout && isNaN(config.timeout)) {
    return false;
  }
  if (config.headers && !isObject(config.headers)) {
    return false;
  }
  return true;
};

const validators = {
  isObject,
  isFunction,
  has,
  isString,
  validateRequest,
  validateConfig,
};

export { validateConfig, validateRequest };
export default validators;
